import api from "../../axios/api.js";

export class MyCCIsService {
  async getMyCCIs() {
    const data = await api.get("MyCCIs");
    return data;
  }
}
